import { UseFormSetError } from "react-hook-form";
import { BodyEditorProvider } from "../../context/GrapeJsBodyContext";
import { FooterEditorProvider } from "../../context/GrapeJsFooterContext";
import { HeaderEditorProvider } from "../../context/GrapeJsHeaderContext";
import { IPage } from "../../types/interface";
import GrapesJSEditor from "../GrapesjsEditor/PageEditor/GrapesJSEditor";

interface PageInfo extends IPage {
  html_content?: string;
  css_content?: string;
  projectData?: Record<string, any>;
}

interface Props {
  handleUpdate: (
    data: IPage,
    setError: UseFormSetError<IPage>
  ) => Promise<void>;
  isUpdatingPage: boolean;
  pageInfo: PageInfo;
}

export default function EditPage({
  handleUpdate,
  isUpdatingPage,
  pageInfo,
}: Props) {
  return (
    <>
      <BodyEditorProvider>
        <FooterEditorProvider>
          <HeaderEditorProvider>
            <GrapesJSEditor />
          </HeaderEditorProvider>
        </FooterEditorProvider>
      </BodyEditorProvider>
    </>
  );
}
